module.exports = __webpack_public_path__ + "img/jola.0a91307d.png";